(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name ImagenesMultController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('ImagenesMultController', ImagenesMultController);

    ImagenesMultController.$inject = ["ImagenesMultService","$timeout","$location",'$anchorScroll','$uibModal'];

    function ImagenesMultController(ImagenesMultService,$timeout,$location,$anchorScroll,$uibModal)
    {
    	var vm = this;
        vm.pag = 0;
        vm.maxPages = 0;
        vm.categoria_id = {};
        vm.buscador = "";
        vm.imagenes = [];
		vm.modalImg = "";
        vm.loading = false;

        vm.getImagenesMult = function(){
            vm.loading = true;
            ImagenesMultService.getImagenesMult(vm,function(data){
                vm.loading = false;
                vm.imagenes = data.imagenes;
                vm.maxPages = data.maxPages;
                if(vm.pag>0){
                    $("html, body").animate({ scrollTop: $('.filters-news').offset().top }, 1000);
                }

                //console.log(vm.maxPages );
            },function(){vm.loading = false;});
        };

 		
        vm.mostrarPop = function(img){
        	vm.modalImg = $uibModal.open({
	          animation: true,
	          ariaLabelledBy: 'modal-title-top',
	          ariaDescribedBy: 'modal-body-top',
	          templateUrl: 'popimg.html',
	          size: 'xl',
	          //backdrop:'static',
	          controller: function($scope) {
	              $scope.img = img;
	             
	            $scope.okForm = function(){
	                vm.modalImg.close();
	            }
	           
	          }
	      	});

        }

        vm.next = function(){
        	vm.pag++;
        	vm.getImagenesMult();
        }
        vm.prev = function(){
        	vm.pag--;
        	vm.getImagenesMult();
        }

    }


})();